import { MaintenanceOrderActivitiesTableModel } from "../tables/maintenance/maintenance-order-activities-table.model";
import { MaintenanceOrderSuppliesTableModel } from "../tables/maintenance/maintenance-order-supplies-table.model";

export class MaintenanceOrderPrintModel {
  maintenanceOrderId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseName: string = "";
  branchName: string = "";
  consecutive: number = 0;
  dateMaintenanceOrder: Date = new Date();
  typeMaintenanceOrder: string = "";
  clientName: string = "";
  clientAddress: string = "";
  clientPhone: string = "";
  costCenterName: string = "";
  constructionSiteName: string = "";
  constructionSiteAddress: string = "";
  constructionSitePhone: string = "";
  mechanicName: string = "";
  dateCompromise: Date | null = null;
  qualification: number | null = null;
  deliveredOnTime: string = "";
  equiptmentName: string = "";
  equiptmentCode: number = 0;
  equipmentAlterCode: string = "";
  trademark: string = "";
  reference: string = "";
  serie: string = "";
  commercialName: string = "";
  equiptmentType: string = "";
  engineType: string = "";
  voltage: string = "";
  power: string = "";
  amperage: string = "";
  nextMaintenancePlan: number = 0;
  nextHourometer: number = 0;
  initialDiagnosis: string = "";
  dateInitialMaintenanceOrder: Date | null = null;
  finalDiagnosis: string = "";
  dateFinalMaintenanceOrder: Date | null = null;
  driver: string = "";
  vehicle: string = "";
  transportValue: number = 0;
  userAuthenticated: string = "";

  maintenanceOrderActivities: MaintenanceOrderActivitiesTableModel[] = [];
  maintenanceOrderSupplies: MaintenanceOrderSuppliesTableModel[] = [];
}